/** Session traces UI + live recording. Off in production unless explicitly enabled. */
export function isSessionTracesEnabled(): boolean {
  const flag = process.env.NEXT_PUBLIC_ENABLE_SESSION_TRACES?.trim().toLowerCase();
  if (flag === "true" || flag === "1") return true;
  if (flag === "false" || flag === "0") return false;
  return process.env.NODE_ENV !== "production";
}
